import type { AxiosError } from 'axios';

import EmptyState from 'hb-builder/components/common/state/EmptyState';
import ExclamationMark from 'hb-react/shared/icons/ExclamationMark';

const ErrorState = ({ error }: { error: AxiosError }) => {
  const { data: errorText } = error.response || {};

  const errorMessage =
    typeof errorText === 'string'
      ? errorText
      : s__('Builder|It is impossible to retrieve this content right now.');

  return (
    <EmptyState height="300px" isOver={false}>
      <ExclamationMark height={20} width={20} style={{ marginRight: '4px' }} />
      {errorMessage}
    </EmptyState>
  );
};

export default ErrorState;
